import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["header"]

  connect() {
    this.createSentinel()
    this.observeSentinel()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.sentinel) {
      this.sentinel.remove()
    }
  }

  createSentinel() {
    this.sentinel = document.createElement('div')
    this.sentinel.style.height = '1px'
    this.sentinel.style.pointerEvents = 'none'
    this.sentinel.setAttribute('data-sentinel', '')

    this.headerTarget.parentNode.insertBefore(this.sentinel, this.headerTarget)
  }

  observeSentinel() {
    const options = {
      threshold: [1],
      rootMargin: '0px'
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.headerTarget.classList.add('stuck')
        } else {
          this.headerTarget.classList.remove('stuck')
        }
      })
    }, options)

    this.observer.observe(this.sentinel)
  }
}
